import {KTCard} from '../../../_metronic/helpers'
import {ListHeader} from './components/header/ListHeader'

import {QueryRequestProvider} from './core/QueryRequestProvider'
import {QueryResponseProvider} from './core/QueryResponseProvider'
import {ListViewProvider, useListView} from './core/ListViewProvider'
import {EnquiryTable} from './EnquiryTable'
import {EnquiryEditModal} from './user-enquiry-add-edit/EnquiryEditModal'

const EnquiryList = () => {
  const {itemIdForUpdate} = useListView()
  return (
    <>
      <KTCard>
        <ListHeader />
        <EnquiryTable />
      </KTCard>
      {itemIdForUpdate !== undefined && <EnquiryEditModal />}
    </>
  )
}

const EnquiryListWrapper = () => (
  <QueryRequestProvider>
    <QueryResponseProvider>
      <ListViewProvider>
        <EnquiryList />
      </ListViewProvider>
    </QueryResponseProvider>
  </QueryRequestProvider>
)

export {EnquiryListWrapper}
